import { Injectable } from "@angular/core";
import { DwColumnFormatType, DwColumnRendererParams, DwDecoratorType, DwGridColumn, DwGridColumnDef, DwGridColumnRendererBase, 
         getDefaultColumnStyle, DwEventService } from "@devwareapps/devware-cap";
import { FleetMetaDataItemNames, RoVehicleEntity, FleetVehicleEntity } from "../meta-data/fleet-meta-data.service";
import * as moment_ from 'moment';
const moment = moment_;

@DwGridColumn({
    keyName: 'fleet-isdot-column',
    display: 'Fleet - Is DOT',
    decoratorType: DwDecoratorType.service,
    isGlobal: false,
    parentItemName:  [ FleetMetaDataItemNames.FleetVehicle ],
    allowAttr: false,
    requireAttr: false,
    allowAction: true,
    order: 1,
    columnStyleFunc: getDefaultColumnStyle,
})
@Injectable()
export class FleetVehicleIsDOTColumnService implements DwGridColumnRendererBase {
   
    constructor(
        private dwEventService: DwEventService,
    ) { }
  
    renderColumn(columnConfig: DwGridColumnDef<any>): (params: DwColumnRendererParams) => any {
        return (params) => {
            return "";
            const data: FleetVehicleEntity = params.data;
            if (!data) return "";
            return data.IsDot == true 
                    ? (data.DotInspectionDate?.length > 0 
                        ? moment.utc(data.DotInspectionDate).local().format('MM/DD/YYYY') 
                        : "Yes")
                    : "No";
        }
    }
}